import { apiClient } from '@/shared/lib/axios';
import { clinicApiPath } from '@/shared/lib/apiPath';
import type {
  ReturnRezeptListResponse,
  AddReturnSearchResponse,
  AddReturnSearchParams,
  MarkReturnPayload,
  CancelReturnPayload,
  ResubmitPayload,
} from './types';

const BASE_PATH = '/rezepts/returns';

export async function fetchReturnRezeptList(
  siteType: string,
  clinicNumber: string
): Promise<ReturnRezeptListResponse['data']> {
  const res = await apiClient.get<ReturnRezeptListResponse>(
    clinicApiPath(siteType, clinicNumber, `${BASE_PATH}/`)
  );
  return res.data.data;
}

export async function searchAddReturnRezepts(
  siteType: string,
  clinicNumber: string,
  params: AddReturnSearchParams
): Promise<AddReturnSearchResponse['data']> {
  const res = await apiClient.post<AddReturnSearchResponse>(
    clinicApiPath(siteType, clinicNumber, `${BASE_PATH}/search`),
    {
      search_text: params.searchText,
      page: params.page,
      per_page: params.perPage,
    }
  );
  return res.data.data;
}

export async function markReturnRezepts(
  siteType: string,
  clinicNumber: string,
  payload: MarkReturnPayload
): Promise<void> {
  await apiClient.post(
    clinicApiPath(siteType, clinicNumber, `${BASE_PATH}/mark`),
    payload
  );
}

export async function cancelReturnRezepts(
  siteType: string,
  clinicNumber: string,
  payload: CancelReturnPayload
): Promise<void> {
  await apiClient.post(
    clinicApiPath(siteType, clinicNumber, `${BASE_PATH}/cancel`),
    payload
  );
}

export async function updateResubmissionMonth(
  siteType: string,
  clinicNumber: string,
  payload: ResubmitPayload
): Promise<void> {
  await apiClient.post(
    clinicApiPath(siteType, clinicNumber, `${BASE_PATH}/resubmit`),
    payload
  );
}
